export default __webpack_public_path__ + "static/sunchasers-banner-mobile-a8dff8f48ea14bf0a80edbf621b1e071.webp";